module.exports = __webpack_public_path__ + "fonts/Manrope-800-cyrillic26.765433f.woff2";